<div class="container">
  <div class="header">
    <pdq-heading element="h3">Archive extension</pdq-heading>
    <pdq-button
      [disabled]="isLoading$ | async"
      (onClick)="dialogRef.close()"
      iconColor="var(--on-surface-light)"
      variant="ghost"
      icon="close"></pdq-button>
  </div>
  <div class="wrapper">
    <div class="content">Are you sure?</div>
  </div>
  <footer>
    <pdq-button [disabled]="isLoading$ | async" label="Cancel" (onClick)="dialogRef.close()"></pdq-button>
    <pdq-button
      (onClick)="onArchiveExtension()"
      [loading]="isLoading$ | async"
      variant="danger"
      label="Archive"></pdq-button>
  </footer>
</div>
